import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

export const NotApplicableContainer = styled((props: BoxProps) => (
  <Box display="flex" flexGrow={1} {...props} className={clsx('not-applicable', props.className)} />
))`
  .MuiFormControlLabel-root {
    margin: 0;

    .MuiFormControlLabel-label {
      width: 90px;
      line-height: 14px;
    }
  }
`;
